import { Box, CircularProgress, Typography, Grid } from "@material-ui/core";
import DetailCard from "./DetailCard";
import { useEffect, useRef, useState } from "react";
import { getCompetators } from "../network_requests";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setStates } from "../../../redux/states";
import CustomPagination from "../../../constants/CustomPagination";
import CompetitorsSector from "./CompetitorsSectors";
import CompitatorsFilters from "./CompetitorsFilters";
import DetailCardMobile from "./DetailCardMobile";
import { useParams } from "react-router";
import ListCard from "../../search-results/components/ListCard";
import ListCardMobile from "../../search-results/components/ListCardMobile";

const Competitors = (props) => {
  const [filters, setFilters] = useState({});
  const [load, setLoad] = useState(false);
  const [sectors, setSectors] = useState([]);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const [companies, setCompanies] = useState([]);
  const [countries, setCountries] = useState([]);
  const [continents, setContinents] = useState([]);
  const states = useSelector((state) => state.states.value);
  const [page, setPage] = useState(1);
  const isMounted = useRef(false);
  const isMounted1 = useRef(false);
  const dispatch = useDispatch();
  const [count, setCount] = useState(null);

  let { query, tabValue } = useParams();

  useEffect(async () => {
    setLoad(true);
    setCompanies([]);
    setPage(1);
    const competators = await getCompetators(props.ISIN, filters);
    setCount(competators?.Number_of_companies);
    if (!isMounted1.current) {
      setSectors(competators?.Sector);
      isMounted1.current = true;
    }
    setCountries(competators?.Country);
    setContinents(competators?.Continent);
    setCompanies(competators?.companies);
    setLoad(false);
  }, [
    filters?.Sector,
    filters?.Country,
    filters?.Continent,
    filters?.order_by,
  ]);

  useEffect(async () => {
    if (isMounted.current) {
      setLoad(true);
      const competators = await getCompetators(props.ISIN, {
        ...filters,
        page: page,
      });

      setCompanies([...competators?.companies]);
      setCount(competators?.Number_of_companies);
      setLoad(false);
    } else {
      isMounted.current = true;
    }
  }, [page]);

  useEffect(() => {
    setSectors([]);
  }, [props.ISIN]);

  return (
    <div style={{ marginTop: "24px" }}>
      <CompetitorsSector
        filters={filters}
        setFilters={setFilters}
        Sectors={sectors}
        t={props.t}
      />
      <CompitatorsFilters
        countries={countries}
        continents={continents}
        filters={filters}
        setFilters={setFilters}
        t={props.t}
      />

      <Box
        flexWrap="wrap"
        style={{
          paddingLeft: isDesktopOrLaptop ? "98px" : null,
          paddingRight: isDesktopOrLaptop ? "10px" : null,
          paddingTop: isDesktopOrLaptop ? "5px" : "10px",
        }}
      >
        {isDesktopOrLaptop ? (
          <Grid
            style={{
              paddingLeft: "243px",
              display: "flex",
              width: "757px",
              margin: "10px 0 0 0",
            }}
          >
            <Grid item xs={2}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  cursor: "pointer",
                  textAlign: "center",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                }}
              >
                {props.t("company")}
              </Typography>
            </Grid>
            <Grid item xs={4} />

            <Grid item xs={3}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  height: "27px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {props.t("sector")}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  height: "27px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  textAlign: "end",
                }}
              >
                {props.t("market_cap")}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  height: "27px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {props.t("country")}
              </Typography>
            </Grid>
          </Grid>
        ) : null}
        {companies
          ? companies.map((Company) => {
              return (
                <div
                  style={
                    {
                      //    paddingLeft: isDesktopOrLaptop ? "0px" : "2vw",
                      //  paddingRight: isDesktopOrLaptop ? "0px" : "2vw",
                      //  paddingTop: "20px",
                    }
                  }
                >
                  <Link
                    to={`/search-details/${query}/${Company?.ISIN}/${tabValue}`}
                    style={{ textDecoration: "none" }}
                    onClick={() => {
                      dispatch(
                        setStates({
                          ...states,
                          companies: [...states?.companies, [...companies]],
                        })
                      );
                    }}
                  >
                    {isDesktopOrLaptop ? (
                      <ListCard
                        Company={Company}
                        tabValue={states?.tabValue}
                        t={props.t}
                      />
                    ) : (
                      // <DetailCard
                      //   Company={Company}
                      //   tabValue={states?.tabValue}
                      //   t={props.t}
                      // />
                      <ListCardMobile
                        Company={Company}
                        tabValue={states?.tabValue}
                        t={props.t}
                      />
                      // <DetailCardMobile
                      //   Company={Company}
                      //   tabValue={states?.tabValue}
                      //   t={props.t}
                      // />
                    )}
                  </Link>
                </div>
              );
            })
          : null}
      </Box>
      {!load ? (
        <CustomPagination
          page={page}
          setPage={setPage}
          marginBottom="25px"
          totalPages={Math.ceil(count / 10)}
        />
      ) : null}
      {load ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "5vh",
          }}
        >
          <CircularProgress style={{ color: "#808080" }} />
        </div>
      ) : null}
    </div>
  );
};

export default Competitors;
